import { render, staticRenderFns } from "./AddEditGuidance.vue?vue&type=template&id=4694313a&scoped=true&"
import script from "./AddEditGuidance.vue?vue&type=script&lang=js&"
export * from "./AddEditGuidance.vue?vue&type=script&lang=js&"
import style0 from "./AddEditGuidance.vue?vue&type=style&index=0&id=4694313a&lang=less&scoped=true&"
import style1 from "./AddEditGuidance.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694313a",
  null
  
)

export default component.exports